var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "business-areas" }, [
    _c(
      "div",
      [
        _c(
          "v-tabs",
          {
            attrs: {
              change: _vm.changeTab(_vm.tab),
              "next-icon": "mdi-arrow-right-bold-box-outline",
              "prev-icon": "mdi-arrow-left-bold-box-outline",
              "show-arrows": "",
            },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _c("v-tabs-slider"),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c("v-tab", [
                _c("span", [
                  _vm._v(
                    "\n                       " +
                      _vm._s(item.label) +
                      "\n                "
                  ),
                ]),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "v-tabs-items",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          _vm._l(_vm.items, function (item) {
            return _c(
              "v-tab-item",
              [
                _c("v-card", { attrs: { flat: "" } }, [
                  _c("div", { staticClass: "business-areas__content" }, [
                    _c("div", { staticClass: "business-areas__img" }, [
                      _c("img", { attrs: { src: item.src, alt: "" } }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "business-areas__descr d-flex flex-column justify-content-center",
                      },
                      [
                        _c("div", { staticClass: "business-areas__title" }, [
                          _vm._v(_vm._s(item.label)),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "business-areas__text",
                          domProps: { innerHTML: _vm._s(item.descr) },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "business-areas__table" },
                          _vm._l(item.table, function (itemTable) {
                            return _c(
                              "div",
                              { staticClass: "business-areas__table--item" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(itemTable.name) +
                                    "\n                                    "
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(itemTable.quantity)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "business-areas__btn btn-red ",
                            attrs: { href: item.url },
                          },
                          [_vm._v("Подробнее")]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }